import React, { useEffect } from "react";

import { useShopifyCart } from "@app/scripts/react-hooks/shopify";
import { CartFreeShipping } from "@app/scripts/react-cart/components/CartFreeShipping";
import { CartItems } from "@app/scripts/react-cart/components/CartItems";
import { CartOrderSummary } from "@app/scripts/react-cart/components/CartOrderSummary";

import type { FreeShipping, GiftProduct } from "@app/scripts/types";

type Props = {
  additionalCheckout?: string | null;
  freeShipping?: FreeShipping;
  giftProduct?: GiftProduct;
  lowStockThreshold: number;
  shippingHeading?: string;
  shippingHeadingUnder?: string;
};

export const CartMain: React.FC<Props> = ({
  freeShipping,
  additionalCheckout,
  giftProduct,
  lowStockThreshold,
  shippingHeading,
  shippingHeadingUnder,
}) => {
  const shopifyCart = useShopifyCart({ giftProduct });
  const {
    products,
    cart,
    fetchCart,
    goToCheckout,
    handleUpdate,
    totalDiscount,
    addOosVariant,
    cartTotal,
    giftIds,
    giftMessage,
    giftsInCart,
    overGiftThreshold,
    cartBeforeDiscountPrice,
    qualifyingSubtotal,
  } = shopifyCart;

  useEffect(() => {
    fetchCart();
  }, []);

  return (
    <>
      <div className="cart-main__inner">
        <div className="hide-desktop">
          <CartFreeShipping cart={cart} freeShipping={freeShipping} qualifyingSubtotal={qualifyingSubtotal} />
        </div>

        <div className="cart-main__left">
          <CartItems
            shopifyCart={shopifyCart}
            lowStockThreshold={lowStockThreshold}
            notifyLabel="Notify Me"
            isCartMain
          />
        </div>

        <div className="cart-main__right">
          <div className="hide-mobile">
            <CartFreeShipping
              cart={cart}
              freeShipping={freeShipping}
              shippingHeading={shippingHeading}
              shippingHeadingUnder={shippingHeadingUnder}
              qualifyingSubtotal={qualifyingSubtotal}
            />
          </div>

          <CartOrderSummary
            totalDiscount={totalDiscount}
            cart={cart}
            goToCheckout={goToCheckout}
            cartTotal={cartTotal}
            additionalCheckout={additionalCheckout}
            view="cart_page"
            cartBeforeDiscountPrice={cartBeforeDiscountPrice}
          />
        </div>
      </div>
    </>
  );
};
